import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/team-lead/flag-icon.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-ff28f688"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "container",
  role: "main",
  "data-test": "my-development-view"
}
const _hoisted_2 = {
  key: 0,
  class: "team-lead-grid"
}
const _hoisted_3 = { "data-test": "milestone-title" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "grid-item",
  "data-test": "my-development-levels"
}
const _hoisted_6 = { class: "level-header" }
const _hoisted_7 = { class: "header-text" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "level-content" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Uplifts", -1))
const _hoisted_12 = { class: "uplifts" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Practicalities", -1))
const _hoisted_15 = { class: "practicalities" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "level-button-container" }
const _hoisted_18 = ["href"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 0,
  class: "complete-error-message"
}
const _hoisted_22 = {
  class: "text-center text-danger",
  "data-test": "level-complete-error"
}
const _hoisted_23 = {
  class: "milestone-modal",
  "data-test": "milestone-modal"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "New Milestone!", -1))
const _hoisted_25 = { class: "milestone-badge" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Milestone Flag"
}, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Milestone", -1))

import {
  computed,
  nextTick,
  onBeforeUnmount,
  onMounted,
  onUnmounted,
  provide,
  Ref,
  ref,
  triggerRef,
  watch,
} from "vue";
import { Modal } from "uiv";
import axios, { AxiosError } from "axios";
import { debug as d } from "debug";
import usePersonalLevels, { LevelItem } from "../../composables/usePersonalLevels";
import CompletableAccordion from "../../components/reusables/completable-accordion.vue";
import cms from "../../services/cms/cms";
import { CmsDocumentTypes } from "../../services/cms/cms-type-configuration";
import {
  InviteControlApiModel,
  PersonalCompletedLevelsAndMilestonesApiModel,
} from "../../api-models";
import LoadingPage from "../loading-page.vue";
import ProgressCircle from "../../components/reusables/progress-circle.vue";
import { useToggle } from "../../composables/useToggle";
import { Analytics } from "../../services/analytics/analytics";
import errorRedirect from "../../services/utilities/error-redirect";
import { CmsPersonalLevelData } from "../../services/cms/cms-type-definitions";
import LoadingSpinner from "../../components/loading-spinner.vue";
import CompleteLevelModal from "../../components/team-lead-area/complete-level-modal.vue";
import localStorageService from "../../services/utilities/local-storage-service";
import useAxios from "../../composables/api";
import ViewpointsInviteDialog from "../../components/invite-control/viewpoints-invite-dialog.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'my-development',
  setup(__props) {

const debug = d("cs.MyDevelopoment");

const isLoading = ref(true);
const levels = ref<LevelItem[]>([]) as Ref<LevelItem[]>;
const showMilestoneModal = ref(false);

const scrollPosition = ref(0);

const updateScroll = () => {
  scrollPosition.value = window.scrollY;
  localStorageService.save("myDevelopmentScrollPosition", scrollPosition.value);
};

const { prepareLevelsAndMilestones, setLevelsStatus, castAsLevel, setLevelLink, completeLevel } =
  usePersonalLevels();

const activeLevel = computed(() => levels.value.find((level) => level.status === "active"));
const levelOrMilestoneNumber = computed(() => activeLevel.value?.number);

const selectedLevel = ref<LevelItem>(
  levels.value.find((level) => level.status === "active") || ({} as LevelItem),
);
provide("selectedLevel", selectedLevel);

const completeErrorMessage = ref("");
const isSavingCompletion = ref(false);

const levelsCompleted = computed(() => {
  return (
    levels.value.filter((level) => level.status === "completed" && level.type === "level").length +
    1
  );
});

const viewpointsInviteDialog = ref<InstanceType<typeof ViewpointsInviteDialog> | null>(null);

const { data: inviteControlModel, promise: inviteControlModelPromise } =
  useAxios<InviteControlApiModel>("/InviteCodes/ViewpointsReviewInviteModel");

function showViewpointsInviteDialog(): void {
  if (inviteControlModel.value) {
    viewpointsInviteDialog.value?.open(inviteControlModel.value).finally(() => {
      viewpointsInviteDialog.value?.close();
    });
  }
}

function openViewpointsInviteDialog(): void {
  debug("openViewpointsInviteDialog");
  if (inviteControlModel.value) {
    debug("showing immediately");
    showViewpointsInviteDialog();
  } else {
    debug("deferring show");
    inviteControlModelPromise?.then(() => {
      debug("showing after deferral");
      showViewpointsInviteDialog();
    });
  }
}

function onGoClick(levelData: CmsPersonalLevelData, level: LevelItem) {
  if (levelData.level_type === "session") {
    return;
  }
  // can get rid of this button once the invite level becomes a session
  // TODO: handle the viewpoint invites modal
  if (levelData.level_type === "viewpoint-invite-modal") {
    selectedLevel.value = level;
    openViewpointsInviteDialog();
  }
}

async function getPersonalLevelsProgress() {
  const response = await axios.get<PersonalCompletedLevelsAndMilestonesApiModel>(
    "/api/personallevels",
  );

  return response.data;
}

function onAccordionClose(id: string) {
  const index = levels.value.findIndex((level) => level.id === id);
  if (index !== -1) {
    levels.value[index] = { ...levels.value[index], isOpen: false };
    triggerRef(levels);
  }
  localStorageService.save("myDevelopmentOpenLevelId", null);
}

function onAccordionOpen(id: string) {
  const openLevel = levels.value.find((level) => level.id === id);
  localStorageService.save("myDevelopmentOpenLevelId", id);
  levels.value = levels.value.map((level) => ({
    ...level,
    isOpen: level.id === id,
  }));
  Analytics.action("Expanded Level Content", "MyDevelopmentActions", {
    levelTitle: cms.asText(openLevel?.data.title),
    levelNumber: openLevel?.number,
    levelStatus: openLevel?.status,
  });
}

function refreshPage() {
  window.location.reload();
}

const { state: showLevelModal, toggleState: toggleShowLevelModal } = useToggle(false);

function applyDefaultClass(level: LevelItem): boolean {
  //   const parsed = castAsLevel(level.data);
  //   if (!parsed.initiate_pathway) {
  return false;
  //   }

  //   return displayCompleteButton(level);
}

function closeLevelModal() {
  toggleShowLevelModal();
  refreshPage();
}

async function complete(level: LevelItem) {
  if (isSavingCompletion.value) {
    return;
  }

  isSavingCompletion.value = true;
  const { status, errorMessage } = await completeLevel(level);
  if (status.value === "error") {
    completeErrorMessage.value = errorMessage.value;
    isSavingCompletion.value = false;
  }

  if (status.value === "success") {
    isSavingCompletion.value = false;
    toggleShowLevelModal();
  }
}

async function getLevelsData() {
  const response = await cms.getByUid(
    CmsDocumentTypes.CmsPersonalLevelsAndMilestones,
    "personal-levels-master-list",
  );
  return prepareLevelsAndMilestones(response.data.personal_levels_and_milestones_list);
}

onMounted(async () => {
  window.addEventListener("scroll", updateScroll);

  try {
    const [levelsResponse, progressResponse] = await Promise.all([
      getLevelsData(),
      getPersonalLevelsProgress(),
    ]);
    levels.value = levelsResponse;
    if (progressResponse) {
      setLevelsStatus(levels.value, progressResponse);
    }
  } catch (e: unknown) {
    const error = e as AxiosError;
    debug(error.message);
    errorRedirect(error.response?.status || 500);
  } finally {
    isLoading.value = false;
    nextTick(() => {
      window.scrollTo(0, localStorageService.get("myDevelopmentScrollPosition") || 0);
    });
  }
});

async function completeMilestone() {
  try {
    await axios.post("/api/personallevels/CompleteMilestone", {
      title: cms.asText(activeLevel.value?.data.title),
      prismicId: activeLevel.value?.id,
      prismicUid: activeLevel.value?.uid,
      milestoneNumber: activeLevel.value?.number,
    });
  } catch (e) {
    const error = e as AxiosError;
    debug(error.message);
  }
}

watch(levels, async () => {
  if (activeLevel.value?.type === "milestone") {
    await completeMilestone();
    showMilestoneModal.value = true;
  }
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", updateScroll);
});

onUnmounted(() => {
  localStorageService.save("myDevelopmentScrollPosition", scrollPosition.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ViewpointsInviteDialog, {
      ref_key: "viewpointsInviteDialog",
      ref: viewpointsInviteDialog,
      "data-test": "md-invite-modal"
    }, null, 512),
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(levels.value, (level) => {
            return (_openBlock(), _createElementBlock("div", {
              key: level.id,
              class: "grid-row"
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["grid-item level-circle", level.status])
              }, [
                (level.type === 'level')
                  ? (_openBlock(), _createBlock(ProgressCircle, {
                      key: 0,
                      variant: "user",
                      number: level.number,
                      status: level.status
                    }, null, 8, ["number", "status"]))
                  : _createCommentVNode("", true)
              ], 2),
              (level.type === 'milestone')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["grid-item milestone", level.status]),
                    "data-test": "my-development-milestones"
                  }, [
                    _createElementVNode("h4", _hoisted_3, [
                      _createTextVNode(_toDisplayString(_unref(cms).asText(level.data.title)) + " ", 1),
                      (level.status === 'completed')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(Array.from({ length: level.number }, () => "🎉").join("")), 1))
                        : _createCommentVNode("", true)
                    ])
                  ], 2))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(CompletableAccordion, {
                      id: level.id,
                      status: level.status,
                      variant: "user",
                      "is-open": level.isOpen,
                      onAccordionOpened: onAccordionOpen,
                      onAccordionClosed: onAccordionClose
                    }, {
                      trigger: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("h6", {
                              class: _normalizeClass(level.status),
                              "data-test": "level-number"
                            }, "Level " + _toDisplayString(level.number) + ":", 3),
                            _createElementVNode("div", {
                              innerHTML: _unref(cms).asHtml(level.data.title),
                              class: _normalizeClass(["level-title", level.status]),
                              "data-test": "level-title"
                            }, null, 10, _hoisted_8)
                          ])
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", {
                            innerHTML: _unref(cms).asHtml(_unref(castAsLevel)(level.data).description)
                          }, null, 8, _hoisted_10),
                          _hoisted_11,
                          _createElementVNode("ul", _hoisted_12, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(castAsLevel)(level.data).uplifts_list, (uplift, index) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: index,
                                innerHTML: _unref(cms).asHtml(uplift.uplift)
                              }, null, 8, _hoisted_13))
                            }), 128))
                          ]),
                          _hoisted_14,
                          _createElementVNode("ul", _hoisted_15, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(castAsLevel)(level.data).practicalities_list, (practicality, index) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: index,
                                innerHTML: _unref(cms).asHtml(practicality.practicality)
                              }, null, 8, _hoisted_16))
                            }), 128))
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            (_unref(castAsLevel)(level.data).level_type === 'session')
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  href: _unref(setLevelLink)(level),
                                  class: _normalizeClass(["btn", [
                    applyDefaultClass(level) ? 'btn-default-forward' : 'btn-primary-forward',
                  ]]),
                                  "data-test": "level-go-to-session-button"
                                }, _toDisplayString(_unref(cms).asText(_unref(castAsLevel)(level.data).go_button_text)), 11, _hoisted_18))
                              : (_unref(castAsLevel)(level.data).level_type === 'viewpoint-invite-modal')
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    onClick: ($event: any) => (onGoClick(_unref(castAsLevel)(level.data), level)),
                                    class: "btn btn-primary-forward",
                                    type: "button",
                                    "data-test": "level-go-to-other-action-button"
                                  }, _toDisplayString(_unref(cms).asText(_unref(castAsLevel)(level.data).go_button_text)), 9, _hoisted_19))
                                : _createCommentVNode("", true),
                            (level.status !== 'completed')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 2,
                                  onClick: ($event: any) => (complete(level)),
                                  class: "btn btn-default-tick",
                                  type: "button",
                                  "data-test": "level-complete-button"
                                }, [
                                  (isSavingCompletion.value)
                                    ? (_openBlock(), _createBlock(LoadingSpinner, {
                                        key: 0,
                                        size: "15px"
                                      }))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(" " + _toDisplayString(isSavingCompletion.value ? "" : "Complete"), 1)
                                ], 8, _hoisted_20))
                              : _createCommentVNode("", true)
                          ]),
                          (completeErrorMessage.value.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                _createElementVNode("p", _hoisted_22, _toDisplayString(completeErrorMessage.value), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["id", "status", "is-open"])
                  ]))
            ]))
          }), 128)),
          (_unref(showLevelModal))
            ? (_openBlock(), _createBlock(CompleteLevelModal, {
                key: 0,
                variant: "user",
                "levels-completed": levelsCompleted.value,
                "model-value": _unref(showLevelModal),
                onCloseCompleteLevelModal: closeLevelModal
              }, null, 8, ["levels-completed", "model-value"]))
            : _createCommentVNode("", true),
          (showMilestoneModal.value)
            ? (_openBlock(), _createBlock(_unref(Modal), {
                key: 1,
                modelValue: showMilestoneModal.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showMilestoneModal).value = $event)),
                header: false,
                footer: false
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", null, [
                      _hoisted_24,
                      _createElementVNode("p", null, "Congratulations on Milestone " + _toDisplayString(levelOrMilestoneNumber.value) + ". Keep up the good work!", 1)
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _hoisted_26,
                      _createElementVNode("h4", null, _toDisplayString(levelOrMilestoneNumber.value), 1),
                      _hoisted_27
                    ]),
                    _createElementVNode("div", { style: {"margin-bottom":"10px"} }, [
                      _createElementVNode("button", {
                        class: "btn btn-primary",
                        onClick: refreshPage,
                        type: "button",
                        "data-test": "milestone-modal-button"
                      }, " Continue ")
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createBlock(LoadingPage, { key: 1 }))
  ]))
}
}

})